import { APIConfiguration } from '@savgroup-front-common/configuration';
import { API_COMMON_ERROR } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.document}session/{sessionId}/fileAttachments/{token}`;

export interface UploadFileAttachmentsOnSessionCommandArgs {
  sessionId: string;
  token: string;
  files: File[];
}

export interface UploadFileAttachmentsOnSessionCommandResponse {
  isSuccess: boolean;
  errors: any[];
}

async function uploadFileAttachmentsOnSessionCommand({
  sessionId,
  token,
  files,
}: UploadFileAttachmentsOnSessionCommandArgs): Promise<
  | BackResponse<UploadFileAttachmentsOnSessionCommandResponse>
  | BackResponseFailure
> {
  try {
    const formData = new FormData();

    const someFileHasUndefinedName = files.some(
      (file) => file.name === 'undefined' || file.name === undefined,
    );

    if (someFileHasUndefinedName) {
      return prepareResponseFailure({
        errors: [{ code: API_COMMON_ERROR.UNHANDLED }],
      });
    }

    files.forEach((file) => {
      formData.append('Files', file);
    });

    const url = ENDPOINT.replace('{sessionId}', sessionId).replace(
      '{token}',
      token,
    );

    return await apiCall<
      BackResponse<UploadFileAttachmentsOnSessionCommandResponse>
    >(url, {
      method: SUPPORTED_METHODS.POST,
      body: formData,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default uploadFileAttachmentsOnSessionCommand;
